export const toBase64File = (
  selectedFile: File,
  cb: (res: string | ArrayBuffer | null) => void
) => {
  const reader = new FileReader();

  reader.readAsDataURL(selectedFile);

  // eslint-disable-next-line unicorn/prefer-add-event-listener
  reader.onload = () => {
    cb(reader.result);
  };

  // eslint-disable-next-line unicorn/prefer-add-event-listener
  reader.onerror = () => {};
};
